const Configuration = require("shared/services/Configuration");
const Storage = require("shared/services/Storage");


const C3_API_BASE_URI = `${Configuration.c3ApibaseUrl}`,
    token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token"),
    BEARER_TOKEN = `Bearer ${token}`;


export const createC3Experience =  (experienceJSON) => {
    if (!token) throw new Error("Missing Token");
    if (!C3_API_BASE_URI) throw new Error("Missing Environment Configuration: C3_API_BASE_URI");

    return fetch(`${C3_API_BASE_URI}/v1/experiences`, {
        body: JSON.stringify(experienceJSON),
        headers: {
            "Content-Type": "application/json",
            Authorization: BEARER_TOKEN,
        },
        method: "POST",
    }).then((response) => response.json());
};

export const copyExperienceAsVariant = (copyExperienceJSON) => {
    if (!token) throw new Error("Missing Token");
    if (!C3_API_BASE_URI) throw new Error("Missing Environment Configuration: C3_API_BASE_URI");

    return fetch(
        `${C3_API_BASE_URI}/v1/copyExperienceAsVariant`,
        {
            body: JSON.stringify(copyExperienceJSON),
            headers: {
                "Content-Type": "application/json",
                Authorization: BEARER_TOKEN,
            },
            method: "POST",
        }
    ).then((response) => response.json());
}

export const updateC3ExpCollection = (collectionJSON) => {
    if (!token) throw new Error("Missing Token");
    if (!C3_API_BASE_URI) throw new Error("Missing Environment Configuration: C3_API_BASE_URI");

    return fetch(
        `${C3_API_BASE_URI}/v1/experienceCollections/${collectionJSON.id}`,
        {
            body: JSON.stringify(collectionJSON),
            headers: {
                "Content-Type": "application/json",
                Authorization: BEARER_TOKEN,
            },
            method: "PUT",
        }
    ).then((response) => response.json());
};

export const getC3ExpCollectionById =  (collectionId) => {
    if (!token) throw new Error("Missing Token");
    if (!C3_API_BASE_URI) throw new Error("Missing Environment Configuration: C3_API_BASE_URI");

    return fetch(
        `${C3_API_BASE_URI}/v1/experienceCollections/${collectionId}`,
        {
            method: "GET",
            headers: {
                Authorization: BEARER_TOKEN,
            },
        }
    ).then((response) => response.json());
};

export const getC3ExperienceById =  (experienceId) => {
    if (!token) throw new Error("Missing Token");
    if (!C3_API_BASE_URI) throw new Error("Missing Environment Configuration: C3_API_BASE_URI");

    return fetch(
        `${C3_API_BASE_URI}/v1/experiences/${experienceId}`,
        {
            method: "GET",
            headers: {
                Authorization: BEARER_TOKEN,
            },
        }
    ).then((response) => response.json());
};

export const c3CreateVariantFromParent = ( parentExperienceId, variantExperienceId) => {
    if (!token) throw new Error("Missing Token");
    if (!C3_API_BASE_URI) throw new Error("Missing Environment Configuration: NEXT_PUBLIC_C3_API_BASE_URI");

    return fetch(
        `${C3_API_BASE_URI}/v1/experienceVariantFromParent?parentExperienceId=${parentExperienceId}&variantExperienceId=${variantExperienceId}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
        }
    ).then((response) => response.json());
}


// WEBPACK FOOTER //
// ./src/editor/ui/editor/CollectionNavigation/C3Services/contentControl.js